import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";

import styles from "./index.module.scss";

export default function AllFiltersScrollButton({
  isShowMobileFilterPopup,
  mobileFilterType,
  mobileFilterTypes,
  onShow,
}: any) {
  const { params } = useSelector((state: any) => state.filter);

  const totalCheckedCnt = useMemo(() => {
    return Object.keys(params).filter(
      (param) => !["marka", "model", "kuzov"].includes(param),
    ).length;
  }, [params]);

  const [scrollTop, setScrollTop] = useState(0);
  // Кнопка висит над карточками, поэтому показываем её только при прокрутке
  // вверх: при прокрутке вниз она не перекрывает «Купить» и цену.
  const [isScrollUp, setIsScrollUp] = useState(false);

  const isShowAllMobileAllFilters = useMemo(() => {
    if (typeof window === "undefined") {
      return false;
    }
    return (
      !isShowMobileFilterPopup &&
      isScrollUp &&
      ((window.innerWidth > 991 && scrollTop > 450) ||
        (window.innerWidth <= 991 && scrollTop > 450))
    );
  }, [scrollTop, isScrollUp, isShowMobileFilterPopup]);

  useEffect(() => {
    let lastScrollY = window.scrollY;
    const onScroll = () => {
      // window.scrollY всегда определён (в отличие от e.target.documentElement,
      // где e.target для scroll-события может прийти как window/элемент → undefined).
      setScrollTop(window.scrollY);
      setIsScrollUp(window.scrollY < lastScrollY);
      lastScrollY = window.scrollY;
    };
    window.addEventListener("scroll", onScroll);

    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return isShowAllMobileAllFilters ? (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    <div
      className={styles.AllFiltersFlexButton}
      onClick={() => {
        onShow();
      }}
    >
      {mobileFilterType === mobileFilterTypes.filter ? (
        <>
          <svg
            width="20"
            height="16"
            viewBox="0 0 20 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 4L13 4M13 4C13 5.65686 14.3431 7 16 7C17.6569 7 19 5.65685 19 4C19 2.34315 17.6569 1 16 1C14.3431 1 13 2.34315 13 4ZM7 12L19 12M7 12C7 13.6569 5.65685 15 4 15C2.34315 15 1 13.6569 1 12C1 10.3431 2.34315 9 4 9C5.65685 9 7 10.3431 7 12Z"
              stroke="#fff"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          Все фильтры {totalCheckedCnt > 0 && <span>{totalCheckedCnt}</span>}
        </>
      ) : (
        <>
          {mobileFilterType === mobileFilterTypes.marka && "Выберите марку"}
          {mobileFilterType === mobileFilterTypes.model && "Выберите модель"}
          {mobileFilterType === mobileFilterTypes.kuzov && "Выберите кузов"}
        </>
      )}
    </div>
  ) : null;
}
